/**
 * @file taskActions.js
 * @location src/store/reducers/taskActions.js
 * @role 업무(Task) 액션 핸들러 — CRUD + 핸드셰이크(읽음) 병합 배럴
 *
 * 분리된 도메인:
 *   crudActions       TOGGLE_TASK/DELETE/RESTORE/ADD/EDIT/CANCEL 등
 *   handshakeActions  ACK_TASK (읽음 수신). 검수/코멘트 액션은 razor ㉓ 로 폐기
 */
import { crudActions }      from './taskActions/crudActions.js';
import { handshakeActions } from './taskActions/handshakeActions.js';

export const taskActions = {
  ...crudActions,
  ...handshakeActions,
};
